import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function DicomStart(){

    const [dicomServerStatus, setDicomServerStatus] = useState('');
    const [dicomServerScuStatus, setDicomServerScuStatus] = useState('');
    const startDicomServer = () => {
    axios.get(baseUrl + 'dicom-server/')
      .then((response) => {
        setDicomServerStatus(response.data.status);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const startDicomServerScu = () => {
    axios.get(baseUrl + 'dicom-server-scu/')
      .then((response) => {
        setDicomServerScuStatus(response.data.status);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'black', backgroundColor: '#e5eaef'}}><i className="fa-solid fa-comment"
        aria-hidden="true" style={{color: 'red'}}></i> Dicom Start</h3>
    <div className="row mt-4">
     <div>
      <button onClick={startDicomServer}>Start DICOM Server</button>
      <button onClick={startDicomServerScu}>Start DICOM SCU Server</button>
       <p style={{ color: dicomServerStatus === 'DICOM SCP operation Started Successfully!' ? 'green' : 'red' }}>
            Status: {dicomServerStatus}
       </p>
       <p style={{ color: dicomServerScuStatus === 'DICOM SCU operation completed!' ? 'green' : 'red' }}>
            Status: {dicomServerScuStatus}
       </p>

    </div>
    </div>
    </section>
  )
}
export default DicomStart;
